import { render } from "./ProductsRenderer.vue?vue&type=template&id=71285fbb&scoped=true"
import script from "./ProductsRenderer.vue?vue&type=script&lang=js"
export * from "./ProductsRenderer.vue?vue&type=script&lang=js"

import "./ProductsRenderer.vue?vue&type=style&index=0&id=71285fbb&lang=scss&scoped=true"
import "./ProductsRenderer.vue?vue&type=style&index=1&id=71285fbb&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71285fbb"]])

export default __exports__